import { render, staticRenderFns } from "./user-bio-2.vue?vue&type=template&id=0623dda8&scoped=true"
import script from "./user-bio-2.vue?vue&type=script&lang=js"
export * from "./user-bio-2.vue?vue&type=script&lang=js"
import style0 from "./user-bio-2.vue?vue&type=style&index=0&id=0623dda8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0623dda8",
  null
  
)

export default component.exports